/*
 * Revyv — effets de scroll premium
 * - Smooth scroll : Lenis (hors éditeur / reduced-motion)
 * - Révélation par section : GSAP + ScrollTrigger (média -> titre -> cascade), sortie "recede", une seule fois
 * - Parallax : GSAP + ScrollTrigger (desktop)
 * - Carousel avis
 * Reveals & parallax désactivés dans l'éditeur (contenu toujours visible pour l'édition) et en reduced-motion.
 */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var isMobile = window.matchMedia('(max-width: 749px)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // Garde-fou : les états "cachés au repos" des révélations ne s'appliquent que si le JS tourne.
  document.documentElement.classList.add('revyv-js');

  // Sections principales + type (imageHeavy = révélation lente/cinématique)
  var revealConfig = [
    { key: 'benefits_revyv', imageHeavy: false },
    { key: 'product_highlight_revyv', imageHeavy: true },
    { key: 'how_it_works_revyv', imageHeavy: false },
    { key: 'matiere_revyv', imageHeavy: true },
    { key: 'reviews_revyv', imageHeavy: false },
    { key: 'faq_revyv', imageHeavy: false },
    { key: 'cta_revyv', imageHeavy: false }
  ];

  function getMedia(section, key) {
    if (key === 'product_highlight_revyv') return section.querySelector('.section-content-wrapper > .group-block');
    if (key === 'matiere_revyv') return section.querySelector('.custom-section-background');
    return null;
  }

  function collectContent(section, media) {
    var wrapper = section.querySelector('.section-content-wrapper');
    if (!wrapper) return [];
    var items = [];
    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (child === media) return;
      // Le carousel d'avis se révèle en bloc (ne pas animer les slides masquées)
      if (child.querySelector && child.querySelector('.revyv-quote-slide')) { items.push(child); return; }
      var content = child.querySelector('.group-block-content');
      var cards = content ? content.querySelectorAll(':scope > .group-block') : [];
      if (child.classList.contains('group-block') && cards.length > 1) {
        Array.prototype.forEach.call(cards, function (c) { items.push(c); });
      } else {
        items.push(child);
      }
    });
    items = items.filter(function (el) {
      return el !== media && !el.classList.contains('revyv-parallax') && !el.querySelector('.revyv-parallax');
    });
    // Un seul groupe de contenu (ex. "Le set Revyv") -> on cascade ses éléments internes
    if (items.length === 1) {
      var gc = items[0].querySelector('.group-block-content');
      if (gc && gc.children.length > 1) items = Array.prototype.slice.call(gc.children);
    }
    return items;
  }

  function revealSection(section, imageHeavy, key) {
    if (section.__revyvReveal) return;
    var media = getMedia(section, key);
    var items = collectContent(section, media);
    if (!items.length && !media) return;
    section.__revyvReveal = true;

    var mediaDur = imageHeavy ? (isMobile ? 0.7 : 1.1) : (isMobile ? 0.5 : 0.6);
    var itemDur = isMobile ? 0.5 : 0.6;
    var stag = imageHeavy ? (isMobile ? 0.08 : 0.1) : (isMobile ? 0.06 : 0.08);
    var yAmt = isMobile ? 18 : 30;
    var scaleFrom = isMobile ? 1.03 : 1.05;

    if (media) gsap.set(media, { autoAlpha: 0, scale: scaleFrom, transformOrigin: 'center center' });
    if (items.length) gsap.set(items, { autoAlpha: 0, y: yAmt });

    function play() {
      var tl = gsap.timeline();
      if (media) tl.to(media, { autoAlpha: 1, scale: 1, duration: mediaDur, ease: 'power2.out' }, 0);
      if (items.length) {
        var title = items[0];
        var rest = items.slice(1);
        tl.to(title, { autoAlpha: 1, y: 0, duration: itemDur, ease: 'power3.out' }, media ? 0.2 : 0.15);
        if (rest.length) {
          tl.to(rest, { autoAlpha: 1, y: 0, duration: itemDur, stagger: stag, ease: 'power3.out' }, media ? 0.35 : 0.3);
        }
      }
    }

    // Déclenchement fiable via IntersectionObserver (fonctionne dans l'éditeur ET la boutique)
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { play(); io.disconnect(); }
        });
      }, { rootMargin: '0px 0px -22% 0px', threshold: 0.01 });
      io.observe(section);
    } else {
      play();
    }

    // Sortie "recede" : léger fade + scale-down quand la section quitte le viewport (desktop, boutique)
    if (!isMobile && !designMode && window.ScrollTrigger) {
      var w = section.querySelector('.section-content-wrapper') || section;
      gsap.fromTo(w, { autoAlpha: 1, scale: 1 }, {
        autoAlpha: 0.75, scale: 0.97, ease: 'none', transformOrigin: 'center top',
        scrollTrigger: { trigger: section, start: 'bottom 65%', end: 'bottom top', scrub: true }
      });
    }
  }

  function setupSectionReveals(scope) {
    // Entrée déclenchée par IntersectionObserver (fiable éditeur + boutique). GSAP anime.
    if (!window.gsap || reduced) return;
    revealConfig.forEach(function (cfg) {
      var section = (scope || document).querySelector('[id$="' + cfg.key + '"]');
      if (section) revealSection(section, cfg.imageHeavy, cfg.key);
    });
  }

  function setupParallax() {
    if (!window.gsap || !window.ScrollTrigger || reduced || isMobile) return;
    gsap.registerPlugin(ScrollTrigger);

    // (Le Hero est géré par setupHeroPin — pas de parallax ici pour éviter les conflits)
    var prodSection = document.querySelector('[id$="product_highlight_revyv"]');
    var prodImg = prodSection && prodSection.querySelector('img');
    if (prodSection && prodImg) {
      prodImg.classList.add('revyv-parallax');
      if (prodImg.parentElement) prodImg.parentElement.style.overflow = 'hidden';
      gsap.set(prodImg, { scale: 1.2, transformOrigin: 'center center' });
      gsap.fromTo(prodImg, { yPercent: -7 }, {
        yPercent: 7, ease: 'none',
        scrollTrigger: { trigger: prodSection, start: 'top bottom', end: 'bottom top', scrub: true }
      });
    }

    window.addEventListener('load', function () { ScrollTrigger.refresh(); });
  }

  // ---------- Hero : entrée simple (pin désactivé — conflit scroll avec Lenis) ----------
  function setupHeroPin() {
    if (!window.gsap || reduced || designMode) return;
    var hero = document.querySelector('[id$="hero_RkimKJ"]');
    if (!hero) return;
    var revyv = hero.querySelector('.hero__content-wrapper .text-block');
    var button = hero.querySelector('.button-custom--button_cta_revyv') ||
                 hero.querySelector('.hero__content-wrapper .button');
    if (revyv) gsap.from(revyv, { autoAlpha: 0, y: 24, duration: 0.9, ease: 'power3.out' });
    if (button) gsap.from(button, { autoAlpha: 0, y: 20, duration: 0.7, delay: 0.3, ease: 'power3.out' });
  }

  // ---------- Hero : spotlight reveal premium (cercle + anneau + zoom + scroll) ----------
  function setupRevyvHeroReveal() {
    if (reduced) return;
    var hero = document.querySelector('[data-revyv-hero]');
    if (!hero) return;
    var reveal = hero.querySelector('.revyv-hero__reveal'); // image fixe, masquée par le cercle
    var img = hero.querySelector('.revyv-hero__img');
    var title = hero.querySelector('.revyv-hero__title');
    var outro = hero.querySelector('.revyv-hero__outro');
    var scrollEl = hero.querySelector('.revyv-hero__scroll');
    if (!reveal) return;

    var isMobileHero = window.matchMedia('(max-width: 767px)').matches;
    var baseR = isMobileHero ? 150 : 230;
    function maxRadius() { return Math.hypot(window.innerWidth, window.innerHeight) * 1.05; }

    var sticky = hero.querySelector('.revyv-hero__sticky') || hero;
    var cx = window.innerWidth / 2, cy = window.innerHeight / 2; // cible = curseur
    var dx = cx, dy = cy;            // position affichée (glisse vers le curseur)
    var cursorActive = isMobileHero; // mobile : cercle centré d'office

    function frame() {
      // Progression calculée nativement (sticky, pas de pin GSAP) : position du Hero dans
      // le scroll. Réversible : remonter referme la lentille et ramène le titre.
      var rect = hero.getBoundingClientRect();
      var range = hero.offsetHeight - window.innerHeight;
      var scrollP = range > 0 ? Math.min(1, Math.max(0, -rect.top / range)) : 0;

      // Glissement du cercle vers le curseur ; recentrage au fil de l'ouverture
      dx += (cx - dx) * 0.12;
      dy += (cy - dy) * 0.12;
      var px = dx + (window.innerWidth / 2 - dx) * scrollP;
      var py = dy + (window.innerHeight / 2 - dy) * scrollP;
      // r = 0 au repos (rien) -> baseR dès que la souris bouge -> plein écran au scroll
      var r = (cursorActive || scrollP > 0) ? baseR + scrollP * (maxRadius() - baseR) : 0;

      reveal.style.setProperty('--x', px + 'px');
      reveal.style.setProperty('--y', py + 'px');
      reveal.style.setProperty('--r', r + 'px');

      // Léger zoom de l'image pendant la révélation
      if (img) img.style.transform = 'scale(' + (1.05 + scrollP * 0.07).toFixed(3) + ')';

      // REVYV : s'estompe à l'ouverture ; revient plein quand on remonte (lentille refermée)
      if (title) {
        if (scrollP > 0.001) {
          title.style.opacity = String(1 - scrollP * 0.85);
          title.style.transform = 'translateY(0) scale(' + (1 - scrollP * 0.18) + ')';
        } else {
          title.style.opacity = '';
          title.style.transform = '';
        }
      }
      if (scrollEl) scrollEl.style.opacity = String(Math.max(0, 1 - scrollP * 5));
      if (outro) {
        var o = Math.max(0, Math.min(1, (scrollP - 0.65) / 0.35));
        outro.style.opacity = String(o);
        outro.style.transform = 'translateY(' + ((1 - o) * 20) + 'px)';
        outro.style.pointerEvents = o > 0.5 ? 'auto' : 'none';
      }
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);

    if (!isMobileHero) {
      sticky.addEventListener('mousemove', function (e) {
        var b = sticky.getBoundingClientRect();
        cx = e.clientX - b.left;
        cy = e.clientY - b.top;
        cursorActive = true;
      });
      sticky.addEventListener('mouseleave', function () { cursorActive = false; });
    }
  }

  function setupLenis() {
    // TEMPORAIRE : Lenis désactivé (bloquait le défilement). Scroll natif rétabli.
    return;
    /* eslint-disable no-unreachable */
    if (!window.Lenis || reduced || designMode) return;
    var lenis = new Lenis({
      duration: 1.2,
      easing: function (t) { return Math.min(1, 1.001 - Math.pow(2, -10 * t)); },
      smoothWheel: true,
      syncTouch: false
    });
    window.__revyvLenis = lenis;
    if (window.gsap && window.ScrollTrigger) {
      lenis.on('scroll', ScrollTrigger.update);
      gsap.ticker.add(function (t) { lenis.raf(t * 1000); });
      gsap.ticker.lagSmoothing(0);
    } else {
      var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
      requestAnimationFrame(raf);
    }
  }

  // ---------- Avis : carousel pull-quote éditorial ----------
  function setupReviewCarousel() {
    var sec = document.querySelector('[id$="reviews_revyv"]');
    if (!sec || sec.__revyvCarousel) return;

    var track = null;
    var contents = sec.querySelectorAll('.group-block-content');
    for (var i = 0; i < contents.length; i++) {
      if (contents[i].querySelectorAll(':scope > .group-block').length > 1) { track = contents[i]; break; }
    }
    if (!track) return;
    var slides = Array.prototype.slice.call(track.querySelectorAll(':scope > .group-block'));
    if (slides.length < 2) return;
    sec.__revyvCarousel = true;

    track.classList.add('revyv-quote-track');
    slides.forEach(function (s, i) {
      s.classList.add('revyv-quote-slide');
      if (i === 0) s.classList.add('is-active');
    });

    var index = 0;
    var dots = [];
    function go(n) {
      slides[index].classList.remove('is-active');
      index = (n + slides.length) % slides.length;
      slides[index].classList.add('is-active');
      dots.forEach(function (d, i) { d.classList.toggle('is-active', i === index); });
    }

    var nav = document.createElement('div');
    nav.className = 'revyv-quote-nav';
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'revyv-quote-arrow'; prev.setAttribute('aria-label', 'Précédent'); prev.innerHTML = '&#8592;';
    var dotsWrap = document.createElement('div');
    dotsWrap.className = 'revyv-quote-dots';
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'revyv-quote-arrow'; next.setAttribute('aria-label', 'Suivant'); next.innerHTML = '&#8594;';

    dots = slides.map(function (s, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'revyv-quote-dot' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Avis ' + (i + 1));
      b.addEventListener('click', function () { go(i); });
      dotsWrap.appendChild(b);
      return b;
    });
    prev.addEventListener('click', function () { go(index - 1); });
    next.addEventListener('click', function () { go(index + 1); });
    nav.appendChild(prev);
    nav.appendChild(dotsWrap);
    nav.appendChild(next);
    track.parentNode.insertBefore(nav, track.nextSibling);
  }

  // ---------- Cursor mask reveal : loupe qui révèle une version zoomée ----------
  function setupCursorMask() {
    if (isMobile) return; // pas de curseur -> pas d'effet (fallback simple)
    var host = document.querySelector('[id$="product_highlight_revyv"] .section-content-wrapper > .group-block');
    if (!host) return;
    var wrap = host.querySelector('.group-block__media-wrapper') || host;

    var layer = document.createElement('div');
    layer.className = 'revyv-mask-layer';
    layer.setAttribute('aria-hidden', 'true');
    wrap.appendChild(layer);
    host.classList.add('revyv-mask-host');

    var rect = host.getBoundingClientRect();
    var tx = rect.width / 2, ty = rect.height / 2; // cible (curseur réel)
    var dx = tx, dy = ty;                           // position affichée (lissée)
    var raf = null;

    function render() {
      dx += (tx - dx) * 0.18; // lerp -> mouvement naturel
      dy += (ty - dy) * 0.18;
      layer.style.setProperty('--x', dx + 'px');
      layer.style.setProperty('--y', dy + 'px');
      // magnifier : la couche zoomée se recale sous le curseur
      layer.style.backgroundPosition =
        (dx / rect.width * 100) + '% ' + (dy / rect.height * 100) + '%';
      if (Math.abs(tx - dx) > 0.4 || Math.abs(ty - dy) > 0.4) {
        raf = requestAnimationFrame(render);
      } else {
        raf = null;
      }
    }
    host.addEventListener('mousemove', function (e) {
      rect = host.getBoundingClientRect();
      tx = e.clientX - rect.left;
      ty = e.clientY - rect.top;
      if (!raf) raf = requestAnimationFrame(render);
    });
    host.addEventListener('mouseenter', function () { host.classList.add('is-revealing'); });
    host.addEventListener('mouseleave', function () { host.classList.remove('is-revealing'); });
  }

  // ========================================================================
  // NOUVELLE DESCENTE ÉDITORIALE (sections revyv-* custom sous le héro)
  // Vanilla JS (sans dépendance GSAP), robuste dans l'éditeur et la boutique.
  // ========================================================================

  // Ticker global partagé (mot-à-mot + ligne de progression des étapes)
  var tickerFns = [];
  var tickerRunning = false;
  function tick() {
    for (var i = 0; i < tickerFns.length; i++) { tickerFns[i](); }
    if (tickerFns.length) requestAnimationFrame(tick);
    else tickerRunning = false;
  }
  function addTicker(fn) {
    tickerFns.push(fn);
    if (!tickerRunning) { tickerRunning = true; requestAnimationFrame(tick); }
  }

  // --- Révélation générique : [data-revyv-reveal] -> .is-in ---
  function setupGenericReveal() {
    var els = document.querySelectorAll('[data-revyv-reveal]');
    if (!els.length) return;
    if (reduced || designMode || !('IntersectionObserver' in window)) {
      Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var d = e.target.getAttribute('data-revyv-delay');
        if (d) e.target.style.transitionDelay = d + 'ms';
        e.target.classList.add('is-in');
        io.unobserve(e.target);
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    Array.prototype.forEach.call(els, function (el) { io.observe(el); });
  }

  // --- Révélation mot à mot : [data-revyv-words] ---
  function setupWordReveal() {
    var containers = document.querySelectorAll('[data-revyv-words]');
    if (!containers.length) return;

    Array.prototype.forEach.call(containers, function (c) {
      var text = (c.textContent || '').trim().replace(/\s+/g, ' ');
      c.textContent = '';
      var words = text.split(' ');
      words.forEach(function (w, i) {
        var s = document.createElement('span');
        s.className = 'revyv-word';
        s.textContent = w;
        c.appendChild(s);
        if (i < words.length - 1) c.appendChild(document.createTextNode(' '));
      });
    });

    if (reduced) {
      Array.prototype.forEach.call(document.querySelectorAll('.revyv-word'), function (w) { w.style.opacity = '1'; });
      return;
    }

    addTicker(function () {
      var vh = window.innerHeight;
      Array.prototype.forEach.call(containers, function (c) {
        var rect = c.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return; // hors écran -> skip
        // Progression : commence quand le haut passe 82% du viewport, finit vers 30%
        var start = vh * 0.82, end = vh * 0.30;
        var p = (start - rect.top) / (start - end);
        p = Math.max(0, Math.min(1, p));
        var ws = c.querySelectorAll('.revyv-word');
        var reveal = p * (ws.length + 4); // +marge pour finir net
        for (var i = 0; i < ws.length; i++) {
          var t = Math.max(0, Math.min(1, reveal - i));
          ws[i].style.opacity = (0.14 + 0.86 * t).toFixed(3);
        }
      });
    });
  }

  // --- Ligne de progression des étapes : [data-revyv-steps-fill] ---
  function setupSteps() {
    var fills = document.querySelectorAll('[data-revyv-steps-fill]');
    if (!fills.length || reduced) return;
    addTicker(function () {
      var vh = window.innerHeight;
      Array.prototype.forEach.call(fills, function (fill) {
        var section = fill.closest('[data-revyv-steps]');
        if (!section) return;
        var rect = section.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        var start = vh * 0.75, end = vh * 0.35;
        var p = (start - rect.top) / (start - end);
        p = Math.max(0, Math.min(1, p));
        fill.style.transform = 'scaleX(' + p.toFixed(3) + ')';
      });
    });
  }

  // --- Parallax léger des fonds immersifs : [data-revyv-parallax] ---
  function setupImmersiveParallax() {
    var els = document.querySelectorAll('[data-revyv-parallax]');
    if (!els.length || reduced || isMobile) return;
    addTicker(function () {
      var vh = window.innerHeight;
      Array.prototype.forEach.call(els, function (el) {
        var host = el.parentElement;
        var rect = host.getBoundingClientRect();
        if (rect.bottom < 0 || rect.top > vh) return;
        // -1 (section en bas) -> 1 (section en haut)
        var prog = (rect.top + rect.height / 2 - vh / 2) / (vh / 2 + rect.height / 2);
        el.style.transform = 'translateY(' + (prog * 8).toFixed(2) + '%)';
      });
    });
  }

  // Garde-fou : révèle immédiatement tout contenu si le fade-in échoue.
  function forceRevealAll() {
    var els = document.querySelectorAll('[data-revyv-reveal]');
    Array.prototype.forEach.call(els, function (el) { el.classList.add('is-in'); });
  }

  function safe(fn) { try { fn(); } catch (e) { if (window.console) console.warn('[revyv]', e); } }

  // --- Product Reveal : le produit "entre" à l'écran au scroll (scrub, sans pin) ---
  function setupProductReveal() {
    if (!window.gsap || !window.ScrollTrigger || reduced) return;
    var els = document.querySelectorAll('[data-revyv-product-reveal]');
    Array.prototype.forEach.call(els, function (el) {
      var trig = el.closest('[data-revyv-pr]') || el;
      gsap.fromTo(el,
        { scale: 1.18, yPercent: 7, autoAlpha: 0.3 },
        { scale: 1, yPercent: 0, autoAlpha: 1, ease: 'none',
          scrollTrigger: { trigger: trig, start: 'top 82%', end: 'top 32%', scrub: true } });
    });
  }

  // --- Curseur custom (desktop, pointeur fin) — subtil, avec inertie ---
  function setupCursor() {
    if (reduced) return;
    if (window.matchMedia('(hover: none), (pointer: coarse)').matches) return;
    var cur = document.createElement('div');
    cur.className = 'rv-cursor';
    var lbl = document.createElement('span');
    lbl.className = 'rv-cursor__label';
    cur.appendChild(lbl);
    document.body.appendChild(cur);

    var tx = window.innerWidth / 2, ty = window.innerHeight / 2, x = tx, y = ty, active = false;
    document.addEventListener('mousemove', function (e) {
      tx = e.clientX; ty = e.clientY;
      if (!active) { active = true; cur.classList.add('is-active'); }
      var t = e.target;
      var overHero = t && t.closest && t.closest('[data-revyv-hero], [data-rv-hero]');
      cur.classList.toggle('is-hidden', !!overHero);
      var media = t && t.closest && t.closest('[data-cursor="view"], [data-cursor="drag"], .revyv-tr__tile, .revyv-ugc__tile');
      var interactive = t && t.closest && t.closest('a, button, [role="button"], [data-cursor], summary, .rv-btn');
      if (media) {
        cur.classList.add('is-media'); cur.classList.remove('is-hover');
        var w = media.getAttribute('data-cursor');
        lbl.textContent = (w && w !== 'shop') ? w : 'View';
      } else if (interactive) {
        cur.classList.add('is-hover'); cur.classList.remove('is-media'); lbl.textContent = '';
      } else {
        cur.classList.remove('is-hover', 'is-media'); lbl.textContent = '';
      }
    });
    document.addEventListener('mouseleave', function () { cur.classList.remove('is-active'); });

    (function loop() {
      x += (tx - x) * 0.2; y += (ty - y) * 0.2;
      cur.style.transform = 'translate3d(' + x.toFixed(2) + 'px,' + y.toFixed(2) + 'px,0) translate(-50%,-50%)';
      requestAnimationFrame(loop);
    })();
  }

  // --- Sticky Add-to-Cart (mobile) : délègue au bouton natif, apparaît quand le CTA sort ---
  function setupStickyCart() {
    var bar = document.querySelector('[data-revyv-sticky-cart]');
    if (!bar) return;
    var nativeAdd = document.querySelector('product-form-component button[name="add"]')
      || document.querySelector('.shopify-product-form button[name="add"]')
      || document.querySelector('form[action*="/cart/add"] [name="add"]');
    var trigger = bar.querySelector('[data-revyv-sticky-add]');
    if (!nativeAdd) return; // pas une page produit avec formulaire
    if (trigger) {
      trigger.addEventListener('click', function () {
        nativeAdd.click();
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { bar.classList.toggle('is-visible', !e.isIntersecting); });
      }, { threshold: 0, rootMargin: '0px 0px -10% 0px' });
      io.observe(nativeAdd);
    } else {
      bar.classList.add('is-visible');
    }
  }

  // --- Drag-to-scroll (galeries horizontales) ---
  function setupDragScroll() {
    var els = document.querySelectorAll('[data-revyv-drag]');
    Array.prototype.forEach.call(els, function (el) {
      var down = false, startX = 0, startL = 0, moved = false;
      el.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        down = true; moved = false; startX = e.clientX; startL = el.scrollLeft;
        el.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        el.scrollLeft = startL - dx;
      });
      window.addEventListener('pointerup', function () {
        if (down) { down = false; el.classList.remove('is-dragging'); }
      });
      el.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); }
      }, true);
    });
  }

  // --- Barre de progression de scroll ---
  function setupProgress() {
    var bar = document.createElement('div');
    bar.className = 'rv-progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      var h = document.documentElement.scrollHeight - window.innerHeight;
      var p = h > 0 ? window.scrollY / h : 0;
      bar.style.transform = 'scaleX(' + Math.min(1, Math.max(0, p)).toFixed(4) + ')';
      ticking = false;
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    update();
  }

  // --- Hero : révélation circulaire (fenêtre HD dans le noir), derrière produit/texte ---
  function setupHeroReveal() {
    if (reduced) return; // CSS masque déjà la couche
    var hero = document.querySelector('[data-rv-hero]');
    if (!hero) return;
    var reveal = hero.querySelector('[data-rv-hero-reveal]');
    if (!reveal) return;
    var coarse = window.matchMedia('(hover: none), (pointer: coarse)').matches;

    if (!coarse) {
      // Desktop : le cercle suit le curseur avec inertie
      var baseR = Math.max(190, Math.min(300, Math.hypot(window.innerWidth, window.innerHeight) * 0.16));
      var b = hero.getBoundingClientRect();
      var tx = b.width / 2, ty = b.height / 2, x = tx, y = ty, tr = 0, r = 0;
      hero.addEventListener('mousemove', function (e) {
        b = hero.getBoundingClientRect();
        tx = e.clientX - b.left; ty = e.clientY - b.top; tr = baseR;
      });
      hero.addEventListener('mouseenter', function () { tr = baseR; });
      hero.addEventListener('mouseleave', function () { tr = 0; });
      (function loop() {
        x += (tx - x) * 0.12; y += (ty - y) * 0.12; r += (tr - r) * 0.10;
        reveal.style.setProperty('--rv-mx', x.toFixed(1) + 'px');
        reveal.style.setProperty('--rv-my', y.toFixed(1) + 'px');
        reveal.style.setProperty('--rv-mr', r.toFixed(1) + 'px');
        reveal.style.setProperty('--rv-bgx', ((x - b.width / 2) * -0.03).toFixed(1) + 'px');
        reveal.style.setProperty('--rv-bgy', ((y - b.height / 2) * -0.03).toFixed(1) + 'px');
        requestAnimationFrame(loop);
      })();
    } else {
      // Mobile/tablette : révélation centrée pilotée par le scroll (subtile)
      reveal.style.setProperty('--rv-mx', '50%');
      reveal.style.setProperty('--rv-my', '44%');
      var maxR = Math.min(window.innerWidth, hero.offsetHeight) * 0.5;
      var ticking = false;
      function upd() {
        var rect = hero.getBoundingClientRect();
        var vh = window.innerHeight;
        var p = (vh - rect.top) / (vh + hero.offsetHeight);
        p = Math.max(0, Math.min(1, p));
        reveal.style.setProperty('--rv-mr', (p * maxR).toFixed(1) + 'px');
        ticking = false;
      }
      window.addEventListener('scroll', function () {
        if (!ticking) { ticking = true; requestAnimationFrame(upd); }
      }, { passive: true });
      window.addEventListener('resize', function () { maxR = Math.min(window.innerWidth, hero.offsetHeight) * 0.5; });
      upd();
    }
  }

  // --- Hero : parallax curseur (profondeur) + sortie cinématique au scroll (un seul rAF) ---
  function setupHeroMotion() {
    if (reduced) return;
    var hero = document.querySelector('[data-rv-hero]');
    if (!hero) return;
    var product = hero.querySelector('[data-rv-parallax="product"]');
    var title = hero.querySelector('[data-rv-parallax="title"]');
    var reveal = hero.querySelector('[data-rv-hero-reveal]');
    var vignette = hero.querySelector('.rv-hero__vignette');
    var foot = hero.querySelector('.rv-hero__foot');
    var kicker = hero.querySelector('.rv-hero__kicker');
    var cue = hero.querySelector('.rv-hero__scroll');
    var isDesktop = window.matchMedia('(min-width: 900px)');
    var fine = !window.matchMedia('(hover: none), (pointer: coarse)').matches;
    var tx = 0, ty = 0, x = 0, y = 0;

    if (fine) {
      hero.addEventListener('mousemove', function (e) {
        var r = hero.getBoundingClientRect();
        tx = (e.clientX - r.left) / r.width - 0.5;
        ty = (e.clientY - r.top) / r.height - 0.5;
      });
      hero.addEventListener('mouseleave', function () { tx = 0; ty = 0; });
    }

    function frame() {
      var rect = hero.getBoundingClientRect();
      // Hors écran (déjà passé) : on saute le travail pour préserver les perfs
      if (rect.bottom < -60 || rect.top > window.innerHeight) { requestAnimationFrame(frame); return; }

      x += (tx - x) * 0.06; y += (ty - y) * 0.06;
      // Progression de sortie : 0 en haut -> 1 quand le hero a défilé ~85% de sa hauteur
      var p = Math.max(0, Math.min(1, -rect.top / (window.innerHeight * 0.85)));
      var e = p * p; // easeIn : discret au début, puis marqué

      if (product) {
        var base = isDesktop.matches ? 'translateY(-50%) ' : '';
        var dx = x * -22, dy = (y * -16) - (e * 70);
        product.style.transform = base + 'translate(' + dx.toFixed(1) + 'px,' + dy.toFixed(1) + 'px) scale(' + (1 - e * 0.12).toFixed(3) + ')';
        product.style.opacity = (1 - e * 0.9).toFixed(3);
      }
      if (title) {
        title.style.transform = 'translate(' + (x * 10).toFixed(1) + 'px,' + ((y * 8) - e * 80).toFixed(1) + 'px)';
        title.style.opacity = (1 - e * 1.15).toFixed(3);
      }
      if (kicker) kicker.style.opacity = (1 - e * 1.5).toFixed(3);
      if (foot) {
        foot.style.opacity = (1 - e * 1.25).toFixed(3);
        foot.style.transform = 'translateY(' + (-e * 34).toFixed(1) + 'px)';
      }
      if (reveal) reveal.style.opacity = (1 - e * 1.2).toFixed(3);
      if (vignette) vignette.style.opacity = (1 - e * 0.55).toFixed(3);
      if (cue) cue.style.opacity = (1 - p * 3).toFixed(3);

      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // Pilote une timeline GSAP (paused) via le scroll natif — fiable (pas de dépendance ScrollTrigger).
  // p = progression de la section dans son propre défilement ; lissée (effet "scrub").
  function driveByScroll(el, tl) {
    var dp = 0;
    function frame() {
      var rect = el.getBoundingClientRect();
      var vh = window.innerHeight;
      // Section pas encore atteinte : timeline au début, on évite tout calcul GSAP.
      if (rect.top > vh) { if (dp !== 0) { dp = 0; tl.progress(0); } requestAnimationFrame(frame); return; }
      // Section déjà dépassée : timeline à la fin, figée.
      if (rect.bottom < 0) { if (dp !== 1) { dp = 1; tl.progress(1); } requestAnimationFrame(frame); return; }
      var range = el.offsetHeight - vh;
      var p = range > 0 ? Math.min(1, Math.max(0, -rect.top / range)) : 0;
      dp += (p - dp) * 0.12;
      if (Math.abs(p - dp) < 0.0005) dp = p;
      tl.progress(dp);
      requestAnimationFrame(frame);
    }
    requestAnimationFrame(frame);
  }

  // --- RVSEQ : séquences scroll cinématiques génériques (what-is / how / when / benefits) ---
  // Une seule mécanique réutilisable : couches média en crossfade + phases (mot + texte)
  // qui se relaient + un "cup" schématique qui se déplace pour montrer le geste.
  // Pilotée par driveByScroll (timeline GSAP paused). Fallback = empilé (géré en CSS).
  function setupSequences() {
    if (reduced || !window.gsap) return; // fallback : .rvseq reste empilé, lisible
    var g = window.gsap;
    var scenes = document.querySelectorAll('[data-rv-seq]');
    Array.prototype.forEach.call(scenes, function (stage) {
      if (stage.__rvseq) return;
      var phases = Array.prototype.slice.call(stage.querySelectorAll('.rvseq__phase'));
      if (phases.length < 2) return;
      stage.__rvseq = true;
      stage.classList.add('is-enhanced');

      var layers = Array.prototype.slice.call(stage.querySelectorAll('.rvseq__layer'));
      var cup = stage.querySelector('.rvseq__cup');
      var dots = Array.prototype.slice.call(stage.querySelectorAll('.rvseq__dot'));
      var fill = stage.querySelector('.rvseq__fill');
      var n = phases.length;
      var slot = 1 / n;
      var tr = Math.min(slot * 0.42, 0.14); // durée d'une transition (progress)
      var vw = window.innerWidth, vh = window.innerHeight;

      var tl = g.timeline({ paused: true });

      // 1) Média : chaque couche occupe un segment de la progression, crossfade aux limites.
      var m = layers.length;
      if (m > 0) {
        var lslot = 1 / m;
        var ltr = Math.min(lslot * 0.42, 0.14);
        layers.forEach(function (l, j) { g.set(l, { autoAlpha: j === 0 ? 1 : 0, scale: 1.08 }); });
        for (var j = 0; j < m; j++) {
          var ls = j * lslot;
          tl.to(layers[j], { scale: 1, ease: 'none', duration: lslot }, ls); // ken burns lent
          if (j > 0) tl.to(layers[j], { autoAlpha: 1, ease: 'none', duration: ltr }, ls - ltr);
          if (j < m - 1) tl.to(layers[j], { autoAlpha: 0, ease: 'none', duration: ltr }, (j + 1) * lslot - ltr);
        }
      }

      // 2) Phases (mot + texte) : la 1re est visible ; les suivantes entrent/sortent.
      phases.forEach(function (p, i) {
        g.set(p, { autoAlpha: i === 0 ? 1 : 0, yPercent: i === 0 ? 0 : 16, scale: i === 0 ? 1 : 1.04 });
      });
      for (var i = 0; i < n; i++) {
        var start = i * slot;
        if (i > 0) {
          tl.to(phases[i], { autoAlpha: 1, yPercent: 0, scale: 1, ease: 'power2.out', duration: tr }, start);
        }
        if (i < n - 1) {
          tl.to(phases[i], { autoAlpha: 0, yPercent: -16, scale: 0.98, ease: 'power1.in', duration: tr }, (i + 1) * slot - tr);
        }
      }

      // 3) Cup schématique : se déplace vers l'état de chaque phase (geste physique).
      if (cup) {
        var cupState = function (p) {
          return {
            x: (parseFloat(p.getAttribute('data-cup-x') || '0')) * vw * 0.32,
            y: (parseFloat(p.getAttribute('data-cup-y') || '0')) * vh * 0.30,
            s: parseFloat(p.getAttribute('data-cup-scale') || '1'),
            r: parseFloat(p.getAttribute('data-cup-rot') || '0')
          };
        };
        var c0 = cupState(phases[0]);
        g.set(cup, { xPercent: -50, yPercent: -50, x: c0.x, y: c0.y, scale: c0.s, rotation: c0.r });
        for (var k = 1; k < n; k++) {
          var cs = cupState(phases[k]);
          tl.to(cup, { x: cs.x, y: cs.y, scale: cs.s, rotation: cs.r, ease: 'power2.inOut', duration: slot },
            (k - 1) * slot + slot * 0.35);
        }
      }

      // 4) Indicateurs (ligne + points) synchronisés à la progression.
      if (fill || dots.length) {
        tl.eventCallback('onUpdate', function () {
          var p = tl.progress();
          if (fill) fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
          if (dots.length) {
            var active = Math.max(0, Math.min(n - 1, Math.floor(p / slot + 1e-4)));
            for (var d = 0; d < dots.length; d++) dots[d].classList.toggle('is-on', d === active);
          }
        });
      }

      driveByScroll(stage, tl);
    });
  }

  // --- CINEMATIC REVEAL : scène qui se découvre (parallax + scale-settle, NON pinné) ---
  // Signature "discovery" distincte de la démonstration horizontale. Ticker partagé (addTicker).
  // Le texte est révélé par setupGenericReveal (data-revyv-reveal). Reduced-motion : rien à faire.
  function setupCinematicReveal() {
    if (reduced) return;
    var scenes = document.querySelectorAll('[data-revyv-cine]');
    if (!scenes.length) return;
    Array.prototype.forEach.call(scenes, function (scene) {
      var img = scene.querySelector('[data-cine-img]');
      if (!img) return;
      addTicker(function () {
        var vh = window.innerHeight;
        var rect = scene.getBoundingClientRect();
        if (rect.bottom < -120 || rect.top > vh + 120) return; // hors écran -> skip
        // p : 0 quand la scène entre par le bas, 1 quand elle sort par le haut
        var p = (vh - rect.top) / (vh + rect.height);
        p = Math.max(0, Math.min(1, p));
        var ty = (p - 0.5) * 12;                              // parallax vertical -6%..6%
        var settle = 1 - Math.min(1, Math.abs(p - 0.5) * 2); // 1 au centre, 0 aux bords
        var scale = 1.12 - settle * 0.12;                    // zoom qui se pose en arrivant au centre
        img.style.transform = 'translate3d(0,' + ty.toFixed(2) + '%,0) scale(' + scale.toFixed(3) + ')';
      });
    });
  }

  // --- SHOP : révélation des 4 cups (clip-wipe piloté au scroll, cup par cup) ---
  // Réutilise le ticker partagé. La vraie photo lineup se dévoile de gauche à droite
  // (le plus grand cup d'abord) jusqu'à montrer les 4 ensemble. Reduced-motion : image entière.
  function setupShopReveal() {
    if (reduced) return;
    var fig = document.querySelector('[data-revyv-shop-cups]');
    if (!fig) return;
    var img = fig.querySelector('.rvshop__cups-img');
    if (!img) return;
    var HIDE = 74; // % masqué au départ (montre ~le 1er cup)
    addTicker(function () {
      var vh = window.innerHeight;
      var rect = fig.getBoundingClientRect();
      if (rect.top > vh) { img.style.clipPath = 'inset(0 ' + HIDE + '% 0 0)'; return; } // pas encore : pré-clippé
      if (rect.bottom < 0) { img.style.clipPath = 'inset(0 0% 0 0)'; return; }           // déjà passé : entier
      // progression : 0 quand le haut entre par le bas, 1 quand la figure est bien dans l'écran
      var p = (vh - rect.top) / (vh * 0.72);
      p = Math.max(0, Math.min(1, p));
      var r = (1 - p) * HIDE;
      img.style.clipPath = 'inset(0 ' + r.toFixed(1) + '% 0 0)';
    });
  }

  // --- HORIZONTAL STEPS : démonstration latérale (scroll vertical -> progression horizontale) ---
  // Zone sticky ; le rail d'étapes glisse horizontalement ; la ventouse reste centrée et mime le geste.
  // Réutilise driveByScroll (timeline GSAP paused). Fallback / reduced-motion : étapes empilées (CSS).
  function setupHorizontalSteps() {
    if (reduced || !window.gsap) return;
    var g = window.gsap;
    var stages = document.querySelectorAll('[data-revyv-hsteps]');
    Array.prototype.forEach.call(stages, function (stage) {
      if (stage.__rvhs) return;
      var track = stage.querySelector('.rvhw2__track');
      var panels = Array.prototype.slice.call(stage.querySelectorAll('.rvhw2__panel'));
      var n = panels.length;
      if (!track || n < 2) return;
      stage.__rvhs = true;
      stage.classList.add('is-enhanced');

      var cup = stage.querySelector('.rvhw2__cup');
      var fill = stage.querySelector('.rvhw2__fill');
      var dots = Array.prototype.slice.call(stage.querySelectorAll('.rvhw2__dot'));
      var endX = -((n - 1) / n) * 100; // % de la largeur du rail
      var seg = 1 / (n - 1);

      var tl = g.timeline({ paused: true });
      tl.to(track, { xPercent: endX, ease: 'none', duration: 1 }, 0);

      // La ventouse reste au centre et mime le geste au fil de la progression (5 étapes)
      if (cup) {
        g.set(cup, { xPercent: -50, yPercent: 0, scale: 0.78, rotation: -6 });
        tl.to(cup, { yPercent: 8, scale: 1.0, rotation: 0, ease: 'sine.inOut', duration: seg }, 0)
          .to(cup, { scale: 1.14, ease: 'sine.inOut', duration: seg }, seg)
          .to(cup, { scale: 1.05, rotation: 3, ease: 'sine.inOut', duration: seg }, seg * 2)
          .to(cup, { yPercent: -10, scale: 0.7, rotation: 8, ease: 'power1.in', duration: seg }, seg * 3);
      }

      // Étape active mise en avant + progression (ligne + points)
      for (var q = 0; q < n; q++) panels[q].style.opacity = (q === 0 ? 1 : 0.28);
      tl.eventCallback('onUpdate', function () {
        var p = tl.progress();
        if (fill) fill.style.transform = 'scaleX(' + p.toFixed(4) + ')';
        var pos = p * (n - 1);
        for (var i = 0; i < n; i++) {
          panels[i].style.opacity = (1 - Math.min(1, Math.abs(i - pos)) * 0.72).toFixed(3);
        }
        if (dots.length) {
          var act = Math.round(pos);
          for (var k = 0; k < dots.length; k++) dots[k].classList.toggle('is-on', k === act);
        }
      });

      driveByScroll(stage, tl);
    });
  }

  // --- PDP : texte de configuration qui suit le variant sélectionné (présentation seule) ---
  // Lit le variant natif (radio/select) et met à jour un texte. NE touche NI au form, NI aux IDs,
  // NI à la soumission. Défaut serveur = neutre -> si le JS échoue, aucun variant n'est mal représenté.
  function setupVariantConfig() {
    var el = document.querySelector('[data-rv-variant-config]');
    if (!el) return;
    var addBtn = document.querySelector('form[action*="/cart/add"] [name="add"], product-form-component [name="add"]');
    var scope = (addBtn && addBtn.closest('.shopify-section')) || document;
    var map = {
      'blue-set': '4 cups · 4 sizes',
      'white-set': 'Recovery System — White',
      'blue-3pcs': '3-cup set',
      'white-3pcs': '3-cup set',
      'xl': 'Single cup · XL',
      'm': 'Single cup · M'
    };
    var fallback = el.getAttribute('data-default') || el.textContent;
    function norm(v) { return (v || '').trim().toLowerCase().replace(/\s+/g, '-'); }
    function current() {
      var r = scope.querySelector('fieldset input[type="radio"]:checked, .variant-option input[type="radio"]:checked, variant-picker input[type="radio"]:checked');
      if (r && r.value) return r.value;
      var s = scope.querySelector('variant-picker select, .variant-option select, select[name*="option" i]');
      if (s && s.value) return s.value;
      return '';
    }
    function update() {
      var key = norm(current());
      el.textContent = map[key] ? map[key] : fallback;
    }
    scope.addEventListener('change', update);
    update();
  }

  // --- SMOKE : dérive scroll subliminale de l'atmosphère bleue partagée (.revyv-smoke) ---
  // Le conteneur (inset:-10%, overflow hidden) glisse très légèrement dans le sens du scroll,
  // puis revient naturellement vers 0. Amplitude ≤ 20px. Le "breathe" reste géré en CSS.
  function setupSmoke() {
    if (reduced) return;
    var els = document.querySelectorAll('.revyv-smoke');
    if (!els.length) return;
    var lastY = window.scrollY || window.pageYOffset || 0;
    var target = 0, ty = 0;
    window.addEventListener('scroll', function () {
      var y = window.scrollY || window.pageYOffset || 0;
      target += (y - lastY) * 0.05; lastY = y;
      if (target > 20) target = 20; else if (target < -20) target = -20;
    }, { passive: true });
    addTicker(function () {
      target *= 0.92;             // revient doucement vers 0 (scroll up compris)
      ty += (target - ty) * 0.08; // lissage
      if (Math.abs(ty) < 0.01) ty = 0;
      var t = 'translate3d(0,' + ty.toFixed(2) + 'px,0)';
      for (var i = 0; i < els.length; i++) {
        var r = els[i].getBoundingClientRect();
        if (r.bottom < 0 || r.top > window.innerHeight) continue; // hors écran -> skip
        els[i].style.transform = t;
      }
    });
  }

  // --- INTRO -> HERO immersif : entrée masquée + traversée de scène (driver natif) ---
  function setupIntroHero() {
    var stage = document.querySelector('[data-revyv-intro-hero]');
    if (!stage || stage.__rvih) return;
    if (reduced || !window.gsap) return; // fallback : empilé, visible
    stage.__rvih = true;
    var g = window.gsap;
    var q = function (s) { return stage.querySelector(s); };
    var arr = function (s) { return Array.prototype.slice.call(stage.querySelectorAll(s)); };

    stage.classList.add('is-enhanced');

    var product = q('.rvih-product');
    var hero = q('.rvih-hero');
    var heroText = q('.rvih-hero__text');
    var texts = arr('.rvih-hero__text > *');
    var introTitle = q('.rvih-intro__title');
    var cue = q('.rvih-intro__cue');
    var light = q('.rvih__light');
    var bodyEl = q('.rvih-body');
    var lines = arr('.rvih-intro__title .rvih-line__in');
    var introExtras = arr('.rvih-intro__eyebrow, .rvih-intro__lead, .rvih-intro__actions');
    var finalScale = window.matchMedia('(max-width: 900px)').matches ? 1.9 : 2.5;

    // États initiaux : HERO caché, produit très petit + tourné, textes plus bas.
    g.set(hero, { autoAlpha: 0 });
    g.set(product, { scale: 0.26, rotation: -18, autoAlpha: 0, transformOrigin: '50% 52%' });
    g.set(texts, { yPercent: 60, autoAlpha: 0 });
    if (light) g.set(light, { autoAlpha: 0.35 });
    if (bodyEl) g.set(bodyEl, { xPercent: 0, autoAlpha: 1 });

    // Entrée INTRO : lignes qui montent (masquées), RECOVERY puis REDEFINED. (stagger).
    g.from(lines, { yPercent: 118, autoAlpha: 0, filter: 'blur(10px)', duration: 1.5, ease: 'power4.out', stagger: 0.16 });
    g.from(cue, { autoAlpha: 0, y: 16, duration: 1, delay: 0.9, ease: 'power2.out' });

    // Traversée de scène (scrub) : l'INTRO tient, se contracte/éloigne/fond ; le HERO émerge ;
    // le produit s'approche (organique) puis grossit au-delà du viewport (caméra qui avance).
    var tl = g.timeline({ paused: true });
    tl.to(cue, { autoAlpha: 0, ease: 'none', immediateRender: false }, 0)
      .to(introTitle, { scale: 0.82, yPercent: -14, autoAlpha: 0, filter: 'blur(6px)', ease: 'power1.inOut', immediateRender: false }, 0.12)
      .to(introExtras, { autoAlpha: 0, yPercent: -10, filter: 'blur(6px)', ease: 'power1.inOut', immediateRender: false, stagger: 0.015 }, 0.12)
      .to(product, { scale: 1, rotation: 0, autoAlpha: 1, ease: 'power2.out' }, 0.14)
      .to(hero, { autoAlpha: 1, ease: 'none' }, 0.30)
      .to(texts, { yPercent: 0, autoAlpha: 1, ease: 'power3.out', stagger: 0.05 }, 0.36)
      .to(light, { autoAlpha: 0.6, ease: 'none' }, 0.40)
      .to(product, { scale: finalScale, yPercent: 10, ease: 'power1.in' }, 0.54)
      .to(heroText, { yPercent: -9, ease: 'none' }, 0.58);

    // Corps athlète : coulisse vers la droite + s'efface quand le produit entre
    if (bodyEl) tl.to(bodyEl, { xPercent: 72, autoAlpha: 0, ease: 'power2.in', duration: 0.3 }, 0.10);

    driveByScroll(stage, tl);
  }

  // --- RECOVERY STORY : scène cinématique scrubbée (une caméra qui traverse) ---
  function setupRecoveryStory() {
    var stage = document.querySelector('[data-revyv-recovery-story]');
    if (!stage || stage.__rvrs) return;
    if (reduced || !window.gsap) return; // fallback empilé
    stage.__rvrs = true;
    var g = window.gsap;
    var q = function (s) { return stage.querySelector(s); };
    stage.classList.add('is-enhanced');

    var media = q('.rvrs__media'), light = q('.rvrs__light');
    var t1 = q('.rvrs__title--1'), t2 = q('.rvrs__title--2'), t3 = q('.rvrs__title--3');
    var product = q('.rvrs__product'), prod = q('.rvrs__product-img');
    var finalScale = window.matchMedia('(max-width: 900px)').matches ? 1.2 : 1.5;

    // États initiaux
    g.set(media, { autoAlpha: 0, scale: 1.14 });
    g.set(light, { autoAlpha: 0 });
    g.set(t1, { autoAlpha: 0, yPercent: 14, scale: 1.05, filter: 'blur(8px)' });
    g.set(t2, { autoAlpha: 0, yPercent: 14, scale: 1.05 });
    g.set(t3, { autoAlpha: 0, yPercent: 16 });
    g.set(product, { autoAlpha: 0 });
    g.set(prod, { scale: 0.28, transformOrigin: '50% 52%' });

    // Timeline (map de progression) : titre -> média -> média dominant ->
    // titre 1 disparaît -> titre 2 -> produit émerge/dominant -> titre 3 (fin).
    var tl = g.timeline({ paused: true });
    tl.to(t1, { autoAlpha: 1, yPercent: 0, scale: 1, filter: 'blur(0px)', ease: 'power3.out', duration: 0.15 }, 0.05)
      .to(media, { autoAlpha: 1, ease: 'none', duration: 0.16 }, 0.32)
      .to(media, { scale: 1, ease: 'power2.out', duration: 0.22 }, 0.32)
      .to(light, { autoAlpha: 0.6, ease: 'none', duration: 0.30 }, 0.34)
      .to(t1, { autoAlpha: 0, yPercent: -12, filter: 'blur(6px)', ease: 'power1.in', duration: 0.12 }, 0.56)
      .to(t2, { autoAlpha: 1, yPercent: 0, scale: 1, ease: 'power3.out', duration: 0.12 }, 0.70)
      .to(product, { autoAlpha: 1, ease: 'none', duration: 0.08 }, 0.78)
      .to(prod, { scale: 1, ease: 'power2.out', duration: 0.14 }, 0.78)
      .to(t2, { autoAlpha: 0, yPercent: -10, ease: 'power1.in', duration: 0.10 }, 0.88)
      .to(prod, { scale: finalScale, ease: 'power1.in', duration: 0.12 }, 0.86)
      .to(product, { autoAlpha: 0.22, ease: 'power1.out', duration: 0.10 }, 0.94)
      .to(t3, { autoAlpha: 1, yPercent: 0, ease: 'power3.out', duration: 0.12 }, 0.93);

    driveByScroll(stage, tl);
  }

  // --- PRODUCT EXPERIENCE (Phase 4) : séquence produit cinématique (driver natif) ---
  function setupProductExperience() {
    var stage = document.querySelector('[data-revyv-product-experience]');
    if (!stage || stage.__rvpx) return;
    if (reduced || !window.gsap) return; // fallback empilé/visible
    stage.__rvpx = true;
    var g = window.gsap;
    var q = function (s) { return stage.querySelector(s); };
    stage.classList.add('is-enhanced');

    var eyebrow = q('.rvpx__eyebrow');
    var cup1 = q('.rvpx__cup--1'), cup2 = q('.rvpx__cup--2'), cup3 = q('.rvpx__cup--3'), cup4 = q('.rvpx__cup--4');
    var titleReveal = q('.rvpx__title--reveal'), rr = q('.rvpx__rr'), light = q('.rvpx__light');
    var co1 = q('.rvpx__callout--1'), co2 = q('.rvpx__callout--2'), co3 = q('.rvpx__callout--3');
    var co1l = q('.rvpx__callout--1 .rvpx__co-line'), co2l = q('.rvpx__callout--2 .rvpx__co-line'), co3l = q('.rvpx__callout--3 .rvpx__co-line');
    var sysT = q('.rvpx__system-title'), sysS = q('.rvpx__system-support'), mantra = q('.rvpx__mantra');
    var mobile = window.matchMedia('(max-width: 900px)').matches;
    var d = Math.min(window.innerWidth, window.innerHeight) * (mobile ? 0.27 : 0.24);

    // États initiaux
    g.set(eyebrow, { autoAlpha: 0 });
    g.set(cup1, { xPercent: -50, yPercent: -50, scale: 0.16, rotationY: 0, rotationX: 0, autoAlpha: 0, filter: 'blur(10px)', transformOrigin: '50% 50%' });
    g.set([cup2, cup3, cup4], { xPercent: -50, yPercent: -50, scale: 0.5, autoAlpha: 0 });
    g.set(titleReveal, { autoAlpha: 0, yPercent: 8, scale: 1.04 });
    g.set(rr, { autoAlpha: 0 });
    g.set([co1, co2, co3], { autoAlpha: 0, y: 12 });
    g.set([co1l, co2l, co3l], { scaleX: 0 });
    g.set([sysT, sysS, mantra], { autoAlpha: 0 });
    g.set(light, { autoAlpha: 0.2 });

    var tl = g.timeline({ paused: true });
    // Scene 01 — reveal (caméra qui s'approche)
    tl.to(eyebrow, { autoAlpha: 1, ease: 'none', duration: 0.05 }, 0.02)
      .to(titleReveal, { autoAlpha: 1, yPercent: 0, scale: 1, ease: 'power3.out', duration: 0.10 }, 0.04)
      .to(cup1, { scale: 0.7, autoAlpha: 1, filter: 'blur(0px)', ease: 'power1.out', duration: 0.14 }, 0.02)
    // Scene 02 — hero produit
      .to(cup1, { scale: 1.05, ease: 'none', duration: 0.12 }, 0.16)
      .to(titleReveal, { autoAlpha: 0, yPercent: -6, ease: 'power1.in', duration: 0.06 }, 0.16)
      .to(rr, { autoAlpha: 1, ease: 'power2.out', duration: 0.06 }, 0.22)
    // Scene 03 — rotation contrôlée (3D)
      .to(cup1, { rotationY: 18, rotationX: -5, scale: 1.18, ease: 'none', duration: 0.14 }, 0.28)
      .to(light, { autoAlpha: 0.6, ease: 'none', duration: 0.14 }, 0.28)
    // Scene 04 — callouts séquencés
      .to(rr, { autoAlpha: 0, ease: 'power1.in', duration: 0.05 }, 0.42)
      .to(co1, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 0.05 }, 0.44)
      .to(co1l, { scaleX: 1, transformOrigin: 'left center', ease: 'power2.out', duration: 0.05 }, 0.44)
      .to(co1, { autoAlpha: 0, ease: 'power1.in', duration: 0.04 }, 0.52)
      .to(co2, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 0.05 }, 0.54)
      .to(co2l, { scaleX: 1, transformOrigin: 'right center', ease: 'power2.out', duration: 0.05 }, 0.54)
      .to(co2, { autoAlpha: 0, ease: 'power1.in', duration: 0.04 }, 0.62)
      .to(co3, { autoAlpha: 1, y: 0, ease: 'power2.out', duration: 0.05 }, 0.64)
      .to(co3l, { scaleX: 1, transformOrigin: 'left center', ease: 'power2.out', duration: 0.05 }, 0.64)
      .to(co3, { autoAlpha: 0, ease: 'power1.in', duration: 0.04 }, 0.70)
    // Scene 05 — 1 gobelet -> 4 (composition losange)
      .to(cup1, { rotationY: 0, rotationX: 0, scale: 0.5, x: 0, y: -d, ease: 'power2.inOut', duration: 0.12 }, 0.70)
      .to(cup2, { autoAlpha: 1, x: -d, y: 0, ease: 'power2.out', duration: 0.09 }, 0.73)
      .to(cup3, { autoAlpha: 1, x: d, y: 0, ease: 'power2.out', duration: 0.09 }, 0.76)
      .to(cup4, { autoAlpha: 1, x: 0, y: d, ease: 'power2.out', duration: 0.09 }, 0.79)
    // Scene 06 — système
      .to(sysT, { autoAlpha: 1, ease: 'power3.out', duration: 0.06 }, 0.84)
      .to(sysS, { autoAlpha: 1, ease: 'none', duration: 0.05 }, 0.87)
      .to(mantra, { autoAlpha: 1, ease: 'power3.out', duration: 0.05 }, 0.90)
    // Scene 07 — plan final (un gobelet redevient dominant)
      .to([sysT, sysS, mantra], { autoAlpha: 0, ease: 'power1.in', duration: 0.05 }, 0.93)
      .to(cup2, { autoAlpha: 0, x: -d * 2.4, ease: 'power1.in', duration: 0.06 }, 0.93)
      .to(cup3, { autoAlpha: 0, x: d * 2.4, ease: 'power1.in', duration: 0.06 }, 0.93)
      .to(cup4, { autoAlpha: 0, y: d * 2.4, ease: 'power1.in', duration: 0.06 }, 0.93)
      .to(cup1, { x: 0, y: 0, scale: 1.3, ease: 'power2.inOut', duration: 0.07 }, 0.93);

    driveByScroll(stage, tl);
  }

  // --- Accordéon FAQ (Phase 6) : un seul ouvert à la fois, hauteur animée via CSS grid-rows ---
  function setupAccordion() {
    var lists = document.querySelectorAll('[data-revyv-accordion]');
    Array.prototype.forEach.call(lists, function (list) {
      var items = Array.prototype.slice.call(list.querySelectorAll('[data-revyv-acc-item]'));
      items.forEach(function (item, i) {
        var btn = item.querySelector('.rvfaq__q');
        if (!btn) return;
        if (i === 0) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        btn.addEventListener('click', function () {
          var willOpen = !item.classList.contains('is-open');
          items.forEach(function (o) {
            o.classList.remove('is-open');
            var b = o.querySelector('.rvfaq__q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });
          if (willOpen) { item.classList.add('is-open'); btn.setAttribute('aria-expanded', 'true'); }
        });
      });
    });
  }

  function init() {
    if (window.gsap && window.ScrollTrigger) {
      safe(function () { gsap.registerPlugin(ScrollTrigger); });
    }
    // Les fade-in d'abord (le plus important : garantir l'affichage)
    safe(setupGenericReveal);
    // Filet de sécurité : si rien n'a été révélé au bout d'1,2 s, tout afficher.
    setTimeout(function () {
      if (!document.querySelector('[data-revyv-reveal].is-in')) forceRevealAll();
    }, 1200);

    safe(setupReviewCarousel);
    safe(setupHeroPin);
    safe(setupRevyvHeroReveal);
    safe(setupParallax);
    safe(function () { setupSectionReveals(document); });
    safe(setupCursorMask);
    safe(setupWordReveal);
    safe(setupSteps);
    safe(setupImmersiveParallax);
    safe(setupProductReveal);
    safe(setupCursor);
    safe(setupIntroHero);
    safe(setupSequences);
    safe(setupCinematicReveal);
    safe(setupHorizontalSteps);
    safe(setupShopReveal);
    safe(setupSmoke);
    safe(setupRecoveryStory);
    safe(setupProductExperience);
    safe(setupAccordion);
    safe(setupHeroReveal);
    safe(setupHeroMotion);
    safe(setupStickyCart);
    safe(setupVariantConfig);
    safe(setupDragScroll);
    safe(setupProgress);
    safe(setupLenis);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () {
    if (window.ScrollTrigger) ScrollTrigger.refresh();
  });
})();
